import { all, fork, put, takeLatest, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getPoojaris as getPoojarisApi,
    addPoojari as addPoojariApi,
    getPoojariDetails,
    updatePoojariDetails,
    deletePoojariByIdApi,
} from 'helpers/api/poojaris';
import { poojariApiResponseSuccess, poojariApiResponseError } from './actions';
import { PoojariActionTypes } from './constants';

/**
 * Fetches poojaris from the API
 * @param {*} payload - limit, page, and tenantId (or other params if needed)
 */
function* getPoojaris({ payload }: any): SagaIterator {
    try {
        const response = yield call(getPoojarisApi, payload);
        const poojaris = response.data;
        console.log('poojaris', poojaris);
        yield put(poojariApiResponseSuccess(PoojariActionTypes.GET_POOJARIS, poojaris));
    } catch (error: any) {
        console.log('Error fetching poojaris:', error);
        yield put(poojariApiResponseError(PoojariActionTypes.GET_POOJARIS, error));
    }
}

function* addPoojari({ payload: poojariDetails }: any): SagaIterator {
    try {
        const response = yield call(addPoojariApi, poojariDetails);
        const createdPoojari = response?.data;
        yield put(poojariApiResponseSuccess(PoojariActionTypes.ADD_POOJARI, createdPoojari));
    } catch (error: any) {
        yield put(poojariApiResponseError(PoojariActionTypes.ADD_POOJARI, error));
    }
}

function* getPoojariDetailsByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(getPoojariDetails, action.payload);
        const poojariDetails = response.data;
        yield put(poojariApiResponseSuccess(PoojariActionTypes.GET_POOJARI_DETAILS, poojariDetails));
    } catch (error: any) {
        yield put(poojariApiResponseError(PoojariActionTypes.GET_POOJARI_DETAILS, error));
    }
}

function* updatePoojariByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(updatePoojariDetails, action.payload);
        const updatedPoojariDetails = response.data;
        yield put(poojariApiResponseSuccess(PoojariActionTypes.UPDATE_POOJARI, updatedPoojariDetails));
    } catch (error: any) {
        yield put(poojariApiResponseError(PoojariActionTypes.UPDATE_POOJARI, error));
    }
}

function* deletePoojariByIdSaga(action: any): SagaIterator {
    try {
        yield call(deletePoojariByIdApi, action.payload);

        yield put(
            poojariApiResponseSuccess(
                PoojariActionTypes.DELETE_POOJARI,
                action.payload
            )
        );

    } catch (error: any) {
        yield put(poojariApiResponseError(PoojariActionTypes.DELETE_POOJARI, 'Failed to delete Poojari'));
    }
}

function* bulkImportPoojarisSaga({ payload: { poojaris } }: any): SagaIterator {
    try {
        const total = poojaris.length;
        const errors: string[] = [];
        
        for (let i = 0; i < total; i++) {
            try {
                yield call(addPoojariApi, poojaris[i]);
                yield put({
                    type: PoojariActionTypes.API_RESPONSE_SUCCESS,
                    payload: { actionType: '@@poojari/BULK_IMPORT_PROGRESS', progress: Math.round(((i + 1) / total) * 100) }
                });
            } catch (err: any) {
                errors.push(`Row ${i + 1}: ${err?.response?.data?.message || err.message || 'Failed'}`);
            }
        }
        
        if (errors.length === total) {
            yield put(poojariApiResponseError(PoojariActionTypes.BULK_IMPORT_POOJARIS, errors.join('; ')));
        } else {
            yield put(poojariApiResponseSuccess(PoojariActionTypes.BULK_IMPORT_POOJARIS, {}));
            if (errors.length > 0) {
                yield put(poojariApiResponseError(PoojariActionTypes.BULK_IMPORT_POOJARIS, errors.join('; ')));
            }
        }
    } catch (error: any) {
        yield put(poojariApiResponseError(PoojariActionTypes.BULK_IMPORT_POOJARIS, error?.message || 'Failed to import'));
    }
}

export function* watchGetPoojaris() {
    yield takeLatest(PoojariActionTypes.GET_POOJARIS, getPoojaris);
}

export function* watchAddPoojari() {
    yield takeEvery(PoojariActionTypes.ADD_POOJARI, addPoojari);
}

export function* watchUpdatePoojariById() {
    yield takeEvery(PoojariActionTypes.UPDATE_POOJARI, updatePoojariByIdSaga);
}

export function* watchGetPoojariDetailsById() {
    yield takeLatest(PoojariActionTypes.GET_POOJARI_DETAILS, getPoojariDetailsByIdSaga);
}

export function* watchDeletePoojariById() {
    yield takeEvery(PoojariActionTypes.DELETE_POOJARI, deletePoojariByIdSaga);
}

export function* watchBulkImportPoojaris() {
    yield takeEvery(PoojariActionTypes.BULK_IMPORT_POOJARIS, bulkImportPoojarisSaga);
}

/**
 * Root poojari saga
 */
function* poojariSaga() {
    yield all([
        fork(watchGetPoojaris),
        fork(watchAddPoojari),
        fork(watchGetPoojariDetailsById),
        fork(watchUpdatePoojariById),
        fork(watchDeletePoojariById),
        fork(watchBulkImportPoojaris),
    ]);
}

export default poojariSaga;
